export const toLocalISO = (dateStr) => new Date(`${dateStr}T00:00:00`).toISOString();
export const toInputDate = (isoStr) => new Date(isoStr).toLocaleDateString('en-CA');
